import React, { useMemo } from 'react';
import { ChannelConnectionProps } from '../ChannelConnection';
import { getPolyglot } from '../../../../../../i18n';
import { useCurrentStateByControlUnitId } from '../../../../../../redux/controlUnit/hooks/useCurrentStateByControlUnitId';
import { DEFAULT_VALUE_SENSOR } from '../../../../../../redux/controlUnit/api/util/constants';

function useChannelAction(props: ChannelConnectionProps) {
  const { channel } = props;
  const polyglot = getPolyglot();
  const {
    channel: channelId = '',
    controlUnitId = '',
    deviceId: commanderId = '',
    name: channelName = '',
  } = channel || {};

  const { actions, loading, cloudConnectivity } =
    useCurrentStateByControlUnitId(commanderId, controlUnitId);

  const action = useMemo(() => {
    return actions?.find((action) => action.metadata.id === channelId);
  }, [actions, channelId]);

  const actionValue = action?.value;
  const actionString = !cloudConnectivity
    ? DEFAULT_VALUE_SENSOR
    : typeof actionValue === 'boolean'
    ? actionValue
      ? polyglot.t('general.on')
      : polyglot.t('general.off')
    : DEFAULT_VALUE_SENSOR;

  return {
    value: actionValue,
    valueString: actionString,
    unit: undefined,
    unitString: undefined,
    loading: loading && actionValue == undefined,
    action: action,
    name: channelName,
    // TODO: is possible that have lag
    // error: action?.event?.state !== 0,
    error: undefined,
  };
}

export default useChannelAction;
